// Auto-generated index of all ChatGPT components

import ChatGPT_Brainstorming from "./chatgpt_components/ChatGPT_Brainstorming.js";
import ChatGPT_Code_Website from "./chatgpt_components/ChatGPT_Code_Website.js";
import ChatGPT_Coding from "./chatgpt_components/ChatGPT_Coding.js";
import ChatGPT_Cover_Letter from "./chatgpt_components/ChatGPT_Cover_Letter.js";
import ChatGPT_Debug_Code from "./chatgpt_components/ChatGPT_Debug_Code.js";
import ChatGPT_Email from "./chatgpt_components/ChatGPT_Email.js";
import ChatGPT_Explain from "./chatgpt_components/ChatGPT_Explain.js";
import ChatGPT_Few_Shot from "./chatgpt_components/ChatGPT_Few_Shot.js";
import ChatGPT_Find_Title from "./chatgpt_components/ChatGPT_Find_Title.js";
import ChatGPT_First_Draft from "./chatgpt_components/ChatGPT_First_Draft.js";
import ChatGPT_Get_Started from "./chatgpt_components/ChatGPT_Get_Started.js";
import ChatGPT_Home from "./chatgpt_components/ChatGPT_Home.js";
import ChatGPT_Intro from "./chatgpt_components/ChatGPT_Intro.js";
import ChatGPT_Resume from "./chatgpt_components/ChatGPT_Resume.js";
import ChatGPT_Roles from "./chatgpt_components/ChatGPT_Roles.js";
import ChatGPT_SoMe_Facebook from "./chatgpt_components/ChatGPT_SoMe_Facebook.js";
import ChatGPT_SoMe_LinkedIn from "./chatgpt_components/ChatGPT_SoMe_LinkedIn.js";
import ChatGPT_SoMe_Twitter from "./chatgpt_components/ChatGPT_SoMe_Twitter.js";
import ChatGPT_Summarize from "./chatgpt_components/ChatGPT_Summarize.js";

const chatgptComponentsMap = {
  "<ChatGPT_Brainstorming />": ChatGPT_Brainstorming,
  "<ChatGPT_Code_Website />": ChatGPT_Code_Website,
  "<ChatGPT_Coding />": ChatGPT_Coding,
  "<ChatGPT_Cover_Letter />": ChatGPT_Cover_Letter,
  "<ChatGPT_Debug_Code />": ChatGPT_Debug_Code,
  "<ChatGPT_Email />": ChatGPT_Email,
  "<ChatGPT_Explain />": ChatGPT_Explain,
  "<ChatGPT_Few_Shot />": ChatGPT_Few_Shot,
  "<ChatGPT_Find_Title />": ChatGPT_Find_Title,
  "<ChatGPT_First_Draft />": ChatGPT_First_Draft,
  "<ChatGPT_Get_Started />": ChatGPT_Get_Started,
  "<ChatGPT_Home />": ChatGPT_Home,
  "<ChatGPT_Intro />": ChatGPT_Intro,
  "<ChatGPT_Resume />": ChatGPT_Resume,
  "<ChatGPT_Roles />": ChatGPT_Roles,
  "<ChatGPT_SoMe_Facebook />": ChatGPT_SoMe_Facebook,
  "<ChatGPT_SoMe_LinkedIn />": ChatGPT_SoMe_LinkedIn,
  "<ChatGPT_SoMe_Twitter />": ChatGPT_SoMe_Twitter,
  "<ChatGPT_Summarize />": ChatGPT_Summarize,
};

export default chatgptComponentsMap;
